import { BsArrowLeft } from "react-icons/bs";
import { useNavigate, useParams } from "react-router-dom";
import { CardComp } from "../../../components";
import ProfileSkeletonLoader from "../../../components/Common/ProfileSkeletonLoader";
import { useGetSingleStaffQuery } from "../../../store/admin/staff";
import StaffEditForm from "./modules/StaffEditForm";

export const EditStaff = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: staffDetails, isLoading, isError, refetch } =
    useGetSingleStaffQuery(id, { skip: !id });

  const profilePath = `/super_admin/staff_registration/view_staff/${id}`;

  if (isLoading) {
    return (
      <section className="px-2 px-lg-4 pb-5">
        <ProfileSkeletonLoader />
      </section>
    );
  }

  if (isError || !staffDetails) {
    return (
      <section className="px-2 px-lg-4 pb-5">
        <CardComp cardClassName="border-0 p-4">
          <p className="mb-3 text-[#525252]">Unable to load this staff profile.</p>
          <button
            type="button"
            className="text-[var(--color-primary)] fw-semibold"
            onClick={() => navigate(-1)}
          >
            Go back
          </button>
        </CardComp>
      </section>
    );
  }

  const fullName = `${staffDetails?.first_name || ""} ${
    staffDetails?.last_name || ""
  }`.trim();

  return (
    <section className="px-2 px-lg-4 pb-5 space-y-4">
      <div className="w-full min-h-[72px] flex gap-2 items-center px-3 px-md-4 bg-white rounded-[10px]">
        <button
          type="button"
          className="border-0 bg-transparent p-1"
          onClick={() => navigate(profilePath)}
          aria-label="Back to staff profile"
        >
          <BsArrowLeft size={26} className="pointer text-[#45464E]" />
        </button>
        <div>
          <h1 className="text-xl md:text-2xl font-bold text-[#45464E] mb-0">
            Edit Staff Profile
          </h1>
          <p className="text-sm text-[#525252] mb-0">
            {fullName || "Staff"} · Update details, role, branch, and photo
          </p>
        </div>
      </div>

      <CardComp cardClassName="border-0 p-3 p-md-4">
        <StaffEditForm
          staffId={id}
          staffDetails={staffDetails}
          onCancel={() => navigate(profilePath)}
          onSuccess={() => {
            refetch();
            navigate(profilePath);
          }}
        />
      </CardComp>
    </section>
  );
};
